let arrayOfAditionalImagesByDefault = [];

fillArrayOfAditionalImagesByDefault();

function fillArrayOfAditionalImagesByDefault() {
  let variants_aditional_images = document.querySelectorAll('.variants_aditional_images');
  variants_aditional_images.forEach(element => {
    if (element.value != "" && element.value.length > 0) {
      arrayOfAditionalImagesByDefault = JSON.parse(element.value);
    }
  });
}

function searchAditionalImages(dataParent) {
  setTimeout(() => {
    let variantImageContainer = dataParent.querySelectorAll(".variant-image-container");
  
    if (variantImageContainer.length === 0) {
      var variantsImageGridForAditionalImages = document.getElementById('variants-image-grid-for-aditional-images');
      if (variantsImageGridForAditionalImages) {
        variantsImageGridForAditionalImages.innerHTML = '';
        arrayOfAditionalImagesByDefault.forEach(element => {
          var b = document.createElement("DIV");
          b.classList.add('variants-image-element');
          b.innerHTML += `<div class="variant-image-container">
              <img src="${element}" alt="" loading="lazy">
            </div>`;
          variantsImageGridForAditionalImages.appendChild(b);
        });
      }
    }
  }, 500);
}

setTimeout(() => {
  if (
    !document
      .querySelector(".product-swiper-loader")
      .classList.contains("d-none")
  ) {
    document.querySelector(".product-swiper-loader").classList.add("d-none");
  }
}, 1500);

window.addEventListener('load', function () {
  const stringToHTML = (str) => {
    // If DOMParser is supported, use it
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, "text/html");
    return doc.body;
  };

  const discountBadgeVariant = (variants, options) => {
    let selectSize;

    if (options[1] === undefined) {
      selectSize = document.querySelector('[name="size"]').value;
    } else {
      selectSize = options[1];
    }

    const variantsFilter = variants.filter(
      (variant) => selectSize == variant.options[1]
    )

    document.querySelectorAll(".variant-discount-badge").forEach((element) => {
      element.innerHTML = "";
    })

    variantsFilter.forEach(variant => {
      {
        if (variant.available === false) {
          const newVariant = variants.filter(variant2 => variant2.available === true)

          newVariant.forEach(variant3 => {
            if (variant3.compare_at_price > variant3.price) {
              const element = document.querySelector(`label[title="color ${variant3.options[0]}"]`);

              if (element != null) {
                element.querySelector(".variant-discount-badge").innerHTML = "Sale"
              }
            }
          })
        } else {
          if (variant.compare_at_price > variant.price) {
            const element = document.querySelector(`label[title="color ${variant.options[0]}"]`);

            if (element != null) {
              element.querySelector(".variant-discount-badge").innerHTML = "Sale"
            }
          }
        }

      }
    });
  }

  // const compareBoldPrices = (regularPrice, variants) => {
  //   const boldPrice = document.querySelector(".normal-price.price-item--regular");
  //   const regularPriceParent = document.querySelector(".normal-price.regular-price");
  //   const formatedRegularPrice = regularPrice.toString().slice(0, -2).slice(0, -3) + "." + regularPrice.toString().slice(0, -2).slice(-3);

  //   if (boldPrice != null) {
  //     const boldPriceFormatted = Number(boldPrice.textContent.replace("$", "").replace(".", "")) * 100;
  //     if (formatedRegularPrice > parseInt(boldPrice.textContent.replace("$", ""))) {
  //       const searchPrice = variants.filter(
  //         (variant) => variant.price === boldPriceFormatted
  //       )

  //       if (searchPrice.length === 0) {
  //         regularPriceParent.classList.add("comp")

  //         boldPrice.classList.remove("d-none");
  //         (!document.querySelector(".compare-price").classList.contains("d-none") ? regularPriceParent.classList.add("d-none") : regularPriceParent.classList.remove("d-none"););
  //       } else {
  //         boldPrice.classList.add("d-none");
  //       }
  //     } else {
  //       boldPrice.classList.add("d-none");
  //     }
  //   }
  // };

  const changePrice = (regularPrice, comparePrice, id) => {
    const regularPriceParent = document.querySelector(".normal-price.regular-price");
    const comparePriceParent = document.querySelector(".compare-price");
    const newPrice = document.querySelector(`input[name="price-variant-${id}"]`);
    const price = regularPrice.toString().slice(0, -2).replace('.', '');
    

    if (!comparePriceParent.classList.contains("d-none")) {
      comparePriceParent.classList.add("d-none");
    }

    if (newPrice != null) {
      console.log("new price ",newPrice , "price original : ", price, " price regular: ", regularPrice);
      const parsedNewPrice = (parseFloat(newPrice.dataset.pricejs)/100);
      const minPrice = Math.min(
        parseFloat(parsedNewPrice), 
        parseFloat(price)
      );
      regularPriceParent.textContent = `$${minPrice}`;
      if (newPrice.dataset.pricejs < comparePrice) {
        comparePriceParent.textContent = `$${comparePrice.toString().slice(0, -2).slice(0, -3) + '.' + comparePrice.toString().slice(0, -2).slice(-3)}`;
        comparePriceParent.classList.remove("d-none");
      }
    } else {
      regularPriceParent.textContent = `$${parseFloat(regularPrice.toString().slice(0, -2)).toLocaleString('es-ES', { minimumFractionDigits: 3 }).slice(0, -4)}`
      if (regularPrice < comparePrice) {
        comparePriceParent.textContent = `$${comparePrice.toString().slice(0, -2).slice(0, -3) + '.' + comparePrice.toString().slice(0, -2).slice(-3)}`;
        comparePriceParent.classList.remove("d-none");
      }
    }

  }

  const updatePrice = (selectedVariant, variants, options) => {
    if (selectedVariant.length > 0) {
      changePrice(selectedVariant[0].price, selectedVariant[0].compare_at_price, selectedVariant[0].id)
    } else {
      const selectedVariant = variants.filter(
        variant => variant.option1 == options[0]
      )

      changePrice(selectedVariant[0].price, selectedVariant[0].compare_at_price, selectedVariant[0].id);
      /* compareBoldPrices(selectedVariant[0].price, variants); */
    }
  }

  const changeWornwearInformation = async (variant, variants) => {
    let id;
    const firstVariantByColor = variants.filter(v => v.option1 === variant.option1)

    if (variant.available && variant.option2) {
      id = document.querySelector('[name="variant_id"]').value;
    } else {
      id = firstVariantByColor[0].id
    }
    const handleUrl = document.querySelector("#product_handle").value

    baseUrl = `/products/${handleUrl}?variant=${id}`
    const data = await getImagesSection(baseUrl, "product-variants-selector");

    const dataParent = stringToHTML(data);
    
    searchAditionalImages(dataParent);

    document.querySelectorAll(".price-ww").forEach((wornwearPrice, i) => {
      wornwearPrice.firstChild.textContent = dataParent.querySelectorAll(".price-ww")[i].firstChild.textContent;
    })
  }

  const openVariantModal = () => {
    const variantElements = document.querySelectorAll(".variants-image-element");
    const modal = document.querySelector(".variants-image-modal-container");
    const close = document.querySelector(".variants-modal-close");
    const overlay = document.querySelector(".variants-overlay");
    variantElements.forEach((element) => {
      element.addEventListener("click", () => {
        const imageId = element.dataset.id;
        modal.classList.add("open");
        overlay.classList.add("open");

        const imageSelected = modal.querySelector(`#${imageId}`);
        imageSelected.scrollIntoView();
      })
    });

    close.addEventListener("click", () => {
      modal.classList.remove("open");
      overlay.classList.remove("open");
    });
  };

  const openVideoModal = () => {
    const videoElement = document.querySelectorAll(".variants-video-element");
    const modal = document.querySelector(".variants-video-modal");
    const close = modal.querySelector(".modal-close");
    const iframe = modal.querySelector("#video_yt_modal");

    videoElement.forEach((element) => {
      element.addEventListener("click", () => {
        modal.classList.add("open");
        iframe.src = `${iframe.dataset.src}?autoplay=1&mute=1`;
      });
    });

    close.addEventListener("click", () => {
      modal.classList.remove("open");
      iframe.src = "";
    });
  };

  const replaceImages = async () => {
    const variants = JSON.parse(document.querySelector('[name="variants"]').value);
    document
      .querySelector(".aditional-images .product-aditional-images-loader")
      .classList.remove("d-none");

    const handleUrl = document.querySelector("#product_handle").value;

    const variantFilterOnlyColor = variants.filter(
      (variant) =>
        variant.option1 ==
        document.querySelector(`.swiper-slide-thumb-active input[name="color"]`)
          .value
    );

    baseUrl = `/products/${handleUrl}?variant=${variantFilterOnlyColor[0].id}`;
    const data = await getImagesSection(baseUrl, "aditional_images");
    printImages(data);

    document
      .querySelector(".aditional-images .product-aditional-images-loader")
      .classList.add("d-none");
  };

  const printImages = (data) => {
    const dataParent = stringToHTML(data);

    const dataContainer = dataParent.querySelector(".variants-image-container");
    const container = document.querySelector(".variants-image-container");

    container.innerHTML = dataContainer.innerHTML;

    const dataContainerModal = dataParent.querySelector(".variants-image-modal-container");
    const containerModal = document.querySelector(".variants-image-modal-container");

    containerModal.innerHTML = dataContainerModal.innerHTML;

    openVariantModal();
    openVideoModal();

    const variantAditionalImageSlider = new Swiper(".variant-image-swiper", {
      speed: 400,
      spaceBetween: 100,
      pagination: {
        el: ".variants-image-container .swiper-pagination",
        type: "fraction",
      },
    });
  };

  const getImagesSection = async (base, section) => {
    try {
      const {
        data: html
      } = await axios.get(`${base}?section_id=${section}`);
      return html;
    } catch (error) {
      console.error(`Error: ${error.message}`);
    }
  };

  const changeSku = async (variant) => {
    const element = document.querySelector(".sku_code");
    if (variant.sku != null) {
      element.innerText = `Estilo Nro. ${variant.sku.split("-")[0]}`;
      handleChangeSkuOMS(variant)
    }
  };

  const changeColorTitle = (slider) => {
    const title = document.querySelector(".variant-title");
    const code = document.querySelector(".variant-code");
    const thumbs = slider.thumbs.swiper.el;
    const activeSlide = thumbs.querySelector('.swiper-slide-thumb-active input[type="radio"]');

    activeSlide.checked = true;

    if (activeSlide != null) {
      title.innerText = activeSlide.dataset.variant_title;
      code.innerText = activeSlide.dataset.variant_code;
    }
  };

  let firstTimeSelected = true;

  const checkStockSize = (variants, selectedVariant) => {
    const productForm = document.querySelector("#pdp_form");
    const filterVariants = variants.filter(
      (variant) => variant.option1 == selectedVariant.option1
    );

    productForm.querySelectorAll(".size-item").forEach((label) => {
      label.classList.remove("disabled");
    });

    filterVariants.forEach((variant) => {
      const labelSize = productForm.querySelector(
        `[title="size ${variant.option2}"]`
      );

      if (variant.available === false) {
        labelSize.querySelector(".size-item").classList.add("disabled");
      }
    });

    productForm.querySelectorAll(`[name="size"]`).forEach((input) => {
      const size = input.value;

      const find = filterVariants.some((e) => e.option2 === size);

      if (find === false) {
        const labelSize = productForm.querySelector(`[title="size ${size}"]`);
        labelSize.querySelector(".size-item").classList.add("disabled");
      }
    });
    // llamar a autoselectVariant luego de renderizar las variantes disponibles.
    // la llamada se hace aquí, porque al ingresar a la PDP todas las variantes son clickleables.
    if (firstTimeSelected) {
      autoselectVariant();
      firstTimeSelected = false;
    }
  };

  const checkStockColor = (variants, selectedVariant) => {
    const productForm = document.querySelector("#pdp_form");

    if (selectedVariant.option2 === undefined) {
      productForm.querySelectorAll(".label-color").forEach((label) => {
        label.parentElement.classList.remove("disabled");
      });
      return;
    }

    const filterVariants = variants.filter(
      (variant) => variant.option2 == selectedVariant.option2
    );

    productForm.querySelectorAll(".label-color").forEach((label) => {
      label.parentElement.classList.remove("disabled");
    });

    filterVariants.forEach((variant) => {
      const labelSize = productForm.querySelector(
        `[title="color ${variant.option1}"]`
      );

      if (variant.available === false && labelSize != null) {
        labelSize.parentElement.classList.add("disabled");
      }
    });

    productForm.querySelectorAll(`[name="color"]`).forEach((input) => {
      const color = input.value;

      const find = filterVariants.some((e) => e.option1 === color);

      if (find === false) {
        const labelSize = productForm.querySelector(`[title="color ${color}"]`);
        labelSize.parentElement.classList.add("disabled");
      }
    });
  };

  const changeAddButtonText = () => {
    const sizeLabels = document.querySelectorAll(".variants-size label input");

    const sizeSelected = Array.from(sizeLabels).some(
      (input) => input.checked === true
    );

    if (sizeSelected === false) {
      const button = document.querySelectorAll(".add-cart-button");

      button.forEach((element) => {
        element.classList.add("initial-state");
        element.textContent = "Selecciona una talla";
      });
    }
  };

  const checkBadges = () => {
    const productTags = JSON.parse(document.querySelector('[name="product_tags"]').value);
    const variantNewBadge = productTags.filter(tag => tag.includes("-new"));
    const variantSaleBadge = productTags.filter(tag => tag.includes("discount:"));

    variantNewBadge.forEach(badge => {
      const color = badge.split("-new")[0].replace("(", "").replace(")", "");
      const badges = document.querySelectorAll(`.variant-badge-${color}`);

      badges.forEach(element => {
        element.innerHTML = `
        <div class="badge badge-blue text-white text-center rounded-circle avenir-bold d-flex">
          <span class="my-auto mx-auto">Nuevo</span>
        </div>
      `
      })
    })

    variantSaleBadge.forEach(badge => {
      const color = badge.split("-")[0].split(":")[1].replace("(", "").replace(")", "");
      const discount = badge.split("-")[1].replace("d", "");
      const badges = document.querySelectorAll(`.variant-badge-${color}`);

      badges.forEach(element => {
        element.innerHTML = `
        <div class="badge text-white text-center rounded-circle avenir-bold d-flex ">
          <span class="my-auto mx-auto">${discount}%</span>
        </div>
      `
      })
    })

  }

  const updateCurrentVariant = (variantFilter) => {
    document.querySelector('[name="current_variant"]').value = JSON.stringify(variantFilter);
  };

  const changeVariant = async (options) => {
    const selectedVariantName = options.join(" / ");
    const variants = JSON.parse(document.querySelector('[name="variants"]').value);
    let variantObject;
    let baseUrl;

    const variantFilter = variants.filter((variant) => variant.title == selectedVariantName);

    if (variantFilter.length > 0) {
      variantObject = variantFilter[0];
      document.querySelector('[name="variant_id"]').value = variantObject.id;
    } else {
      variantObject = {
        available: false,
        option1: options[0],
        option2: options[1],
      };
    }

    updateCurrentVariant(variantFilter);
    updatePrice(variantFilter, variants, options);
    checkStockSize(variants, variantObject);
    checkStockColor(variants, variantObject);
    changeSku(variantObject);
    checkBadges(selectedVariantName);
    changeWornwearInformation(variantObject, variants);

    if (variantObject.available === false) {
      document.querySelectorAll(".add-cart-button").forEach((button) => {
        button.classList.add("disabled");
        button.classList.remove("initial-state");
        button.innerText = "Sin stock";
      });
      // llamar a autoselectVariant luego de renderizar las variantes disponibles.
      // la llamada se hace aquí, porque al ingresar a la PDP todas las variantes son clickleables.
      autoselectVariant(variantObject.option2);
    } else {
      document.querySelectorAll(".add-cart-button").forEach((button) => {
        button.classList.remove("disabled");
        button.classList.remove("initial-state");
        button.innerText = "Agregar al carrito";
        button.onclick = function() {};
      });
    }

    discountBadgeVariant(variants, options);
  };

  const variantName = () => {
    const productForm = document.querySelector("#pdp_form");
    const options = productForm.querySelectorAll('input[name="size"], input[name="color"]');

    let myOptions = [];

    options.forEach((option) => {
      if (option.type == "radio") {
        if (option.checked == true) {
          myOptions = [...myOptions, option.value];
        }
      } else {
        myOptions = [...myOptions, option.value];
      }
    });

    changeVariant(myOptions);
  };

  const listenSizeSelector = () => {
    const productForm = document.querySelector("#pdp_form");

    productForm.addEventListener("change", async (e) => {
      if (
        e.target.name !== "shipping-method" &&
        e.target.name !== "comuna" &&
        e.target.name !== "region" &&
        e.target.name !== "store-picker" &&
        e.target.name !== "address-picker"
      ) {
        variantName();
      }
    })
  }

  swiper.on("slideChange", function () {
    changeColorTitle(swiper);
    variantName();
    changeAddButtonText();
    replaceImages();
  });

  listenSizeSelector();
  variantName();
  openVariantModal();
  openVideoModal();
  /* replaceImages(); */
  changeAddButtonText();

  document.querySelector(".variants-swiper .product-aditional-images-loader").classList.add("d-none");
  document.querySelector(".variants-size").classList.remove("d-none");
})

const variantAditionalImageSlider = new Swiper(".variant-image-swiper", {
  pagination: {
    el: ".variants-image-container .swiper-pagination",
    type: "fraction",
  },
});

const swiperVariants = new Swiper(".variants-swiper", {
  spaceBetween: 5,
  slidesPerView: "auto",
  centeredSlides: false,
  freeMode: false,
  breakpoints: {
    769: {
      slidesPerView: "auto",
      centeredSlides: false,
    }
  }
});

const swiper = new Swiper(".product-swiper", {
  // Optional parameters
  slidesPerView: 1,
  loop: true,
  centeredSlides: true,
  simulateTouch: true,

  // Navigation arrows
  navigation: {
    nextEl: ".product-swiper .swiper-button-next",
    prevEl: ".product-swiper .swiper-button-prev",
  },
  thumbs: {
    swiper: swiperVariants,
  },
  breakpoints: {
    769: {
      slidesPerView: "auto",
    }
  },
  on: {
    init: function () {
      document.querySelector(".product-swiper-loader").classList.add("d-none");
    },
  },
});

const duplicates = document.querySelector(".swiper-slide.product-main-image");

if (duplicates != null) {
  swiper.destroy();

  const Newswiper = new Swiper(".product-swiper", {
    // Optional parameters
    slidesPerView: 1,
    loop: false,
    centeredSlides: true,
    simulateTouch: true,

    // Navigation arrows
    navigation: {
      nextEl: ".product-swiper .swiper-button-next",
      prevEl: ".product-swiper .swiper-button-prev",
    },
    thumbs: {
      swiper: swiperVariants,
    },
    breakpoints: {
      769: {
        slidesPerView: "auto",
      },
    },
    on: {
      init: function () {
        document.querySelector(".product-swiper-loader").classList.add("d-none");
      },
    },
  });
}